import {loader, defaultStrings} from './loader';
import {createStringsLoader, moment} from '@ringcentral/web-modules-core';

export const loadLanguage = createStringsLoader({loader, defaultStrings, moment});
